module.exports = __webpack_public_path__ + "static/media/cs-2.d6823120.jpg";